<template>
  <AppModalEdit
    :value="value"
    :title="editModalTitle"
    :cancel-button-text="canEdit ? 'キャンセル' : '閉じる'"
    :is-exec-button-disabled="!isValid"
    :show-exec-button="canEdit"
    :loading="loading.send"
    :confirm-on-click-cancel="canEdit"
    @input="$emit('input', $event)"
    @clickExec="onSubmit"
    @cancel="onCancel"
    exec-button-text="登録"
    help-page-title="案件設定 ヘルプはこちら"
    help-page-url="https://go.geologic.co.jp/adminmanual_insertion_order"
  >
    <EditForm
      ref="form"
      :insertion-order="insertionOrder"
      :advertiser="advertiser"
      :can-edit="canEdit"
      :sales-account-list="salesAccountList"
      :loading="loading"
      @success="onSuccess"
      @validate="onValidate"
    />
  </AppModalEdit>
</template>

<script>
import EditForm from './Form/EditForm.vue'
import { actions } from '@/vuex/modules/advertiser/insertionOrders/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'

export default {
  name: 'IOModalEdit',
  components: { EditForm },
  props: {
    advertiser: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
    insertionOrder: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
      default: () => {},
    },
    salesAccountList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isValid: false,
    }
  },
  computed: {
    editModalTitle() {
      if (this.insertionOrder.isNew) {
        return '新規案件'
      } else {
        return this.insertionOrder.name
      }
    },
  },
  methods: {
    onSuccess(savedInsertionOrder) {
      if (this.insertionOrder.isNew) {
        this.$store.dispatch(actions.SET_INSERTION_ORDERS, { keyword: '' })
      } else {
        this.$store.dispatch(actions.CHANGE_IO, {
          insertionOrder: savedInsertionOrder,
        })
      }
      this.showSuccessMessage('案件を登録しました')
      this.$emit('success', savedInsertionOrder)
    },
    onValidate(validity) {
      this.isValid = validity
    },
    onSubmit() {
      this.$refs.form.submit()
    },
    onCancel() {
      this.$refs.form.clear()
      this.$emit('cancel')
    },
    showSuccessMessage(message) {
      this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
        type: snackbarType.SUCCESS,
        message,
      })
    },
  },
}
</script>
